import UserService from '@/services/user.service';
import axios from "axios";

export const reviewerModule = {
    namespaced: true,
    state: {
        requests: [],
        reviewer: {},
        reviewers: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createReviewer({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createReviewer");
            data.role_id = '$reviewer'
            return UserService.createUser(axiosSource, data).then(
                async data => {
                    commit('insertReviewer', data)
                    await dispatch('clearRequest', "createReviewer");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateReviewer({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateReviewer");
            return UserService.updateUser(axiosSource, data).then(
                async data => {
                    commit('updateReviewerData', data)
                    await dispatch('clearRequest', "updateReviewer");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteReviewer({commit, dispatch}, reviewerId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteReviewer");
            return UserService.deleteUser(axiosSource, reviewerId).then(
                async data => {
                    commit('removeReviewerFromList', reviewerId)
                    await dispatch('clearRequest', "deleteReviewer");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getReviewer({commit, dispatch}, reviewerId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getReviewer");
            return UserService.getUser(axiosSource, reviewerId).then(
                async data => {
                    commit('updateActiveReviewer', data)
                    await dispatch('clearRequest', "getReviewer");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        listReviewers({commit}) {
            return UserService.listUsersByRole('$reviewer').then(
                data => {
                    commit('updateReviewersList', data);
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateReviewersList(state, data) {
            state.reviewers = new Map()
            for (const entity of data) {
                entity.phone = entity.phone?.replace('+98', '0')
                state.reviewers.set(entity.id, entity)
            }
        },
        insertReviewer(state, data) {
            data.phone = data.phone?.replace('+98', '0')
            state.reviewers.set(data.id, data)
        },
        updateReviewerData(state, data) {
            data.phone = data.phone?.replace('+98', '0')
            state.reviewers.set(data.id, data)
        },
        removeReviewerFromList(state, reviewerId) {
            state.reviewers.delete(reviewerId)
        },
        updateActiveReviewer(state, data) {
            data.phone = data.phone?.replace('+98', '0')
            state.reviewer = data;
        },
    }
};